// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export let OrderEditBaseUtils = function () { };

OrderEditBaseUtils.LIMIT_PRICE_PARAM = 'limitPrice'
OrderEditBaseUtils.STOP_PRICE_PARAM = 'stopPrice'
OrderEditBaseUtils.SLTP_PARAM = 'sltp'
OrderEditBaseUtils.TRAILING_STOP_PARAM = 'trailingStop'
OrderEditBaseUtils.POSITION_SIZING_PARAM = 'positionSizing'
OrderEditBaseUtils.REAL_TRSTOP_PRICE = 'RealTrStopPrice'
OrderEditBaseUtils.PRODUCT_TYPE_AND_MQ = 'ModifyQuantity' //Target product type + Modify quantity
OrderEditBaseUtils.ATTENTION_MSG = 'attention';
OrderEditBaseUtils.LIMIT_PRICE_PARAM_CHANGE_FROM_LAST_PRICE = 'limitPriceChangeFromLast';   // https://tp.traderevolution.com/entity/108864
OrderEditBaseUtils.SLTP_TRIGGER = 'sltpTrigger'  // for position with sltp & triggers modify #109386

export let OrderEditRequestData = function ()
{
    this.orderTypeId = null
    this.instrument = null
    this.account = null
    this.quote = null
    this.side = null
    this.tif = null
    this.quantity = null
    // TODO. Rename.
    this.parameterDict = {}
    this.placedFrom = null
    this.disclosedQuantity = null
}

